import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "style-guide/component/Typography";
import Button from "style-guide/component/Button";
import ProfileDetails from "./ProfileDetails";
import Security from "./Security";
import AddUserModal from "./AddUserModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "redux/store";
import Loading from "style-guide/component/Loader";
import Company from "./Company";
import { updateCompanyLogo } from "../../../redux/slice/rfpModuleSlice/dashboard";
import {
  setShowToast,
  updateProfileData,
} from "../../../redux/slice/rfpModuleSlice/application";

const Settings = () => {
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { userProfile, isLoading } = useSelector(
    (state: RootState) => state.applicationData
  );

  const handleUpload = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await dispatch(updateCompanyLogo(formData));
    const tempUrl = URL.createObjectURL(file);
    if (res === 200) {
      dispatch(
        updateProfileData({
          companyLogo: tempUrl,
        })
      );
      dispatch(
        setShowToast({
          show: true,
          type: "success",
          toastMessage: "Company Logo Updated Successfully!",
        })
      );
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="w-full flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <Typography variant="Heading 1" text="Settings" />
        <Button
          type="Default"
          buttonText="Help & Support"
          onClick={() => navigate("/help-support")}
          size="Medium"
          className="mr-10"
        />
      </div>
      {/* Profile Details */}
      <div className="border-t-2 border-[whitesmoke]">
        <ProfileDetails data={userProfile.userDetails[0]} />
        {/* Company Logo */}
        <Company
          logoUrl={userProfile?.userDetails[0]?.companyLogo}
          onUpload={handleUpload}
          companyName={userProfile?.userDetails[0]?.companyName}
        />
        {/* Security */}
        <Security />
      </div>

      {/* Add User Modal */}
      <AddUserModal
        showModal={showAddUserModal}
        setShowModal={setShowAddUserModal}
      />
    </div>
  );
};

export default Settings;
